import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import Color from '@tool/color';
import moIndex from '../../../store/index';
import { newValue, newRate } from '@tool/index';

const moSalaryCity = observable({
  isCity: false,
  backupChoose: <any[]>[],
  backupCity: <any[]>[],
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  tableHead: <any[]>[],
  pageNum: 0,
  tableNum: 0,
});

const initSalaryCity = action((res: any) => {
  // console.log('+++ 城市涨薪率 +++ ', res);
  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const overview: any[] = [];
  const labels: any[] = [];
  const years: any[] = [];
  const series: any[] = [];
  const tableLeft: any[] = [];
  const tableRight: any[] = [];
  const tableHead: any[] = [];
  let pageNum = 0;
  let tableNum = 0;

  res.data?.map((item: any) => {
    xData.push(item.city);
    series.push(item.year_data);
    tableLeft.push(item.city);
  });

  series.map((item: any) => {
    item?.map((child: any) => {
      years.push(child.date);
    });
  });
  uniq(years).map((year: any) => {
    const temp: any[] = [];
    series.map((item: any) => {
      item?.map((child: any) => {
        if (child.date === year) temp.push(child.change_rate);
      });
    });
    yData.push({
      name: year,
      data: temp,
    });
  });

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  // tableRight.push(uniq(years));
  res.data?.map((item: any) => {
    const temp: any[] = [];
    item.year_data?.map((child: any) => {
      temp.push(child.change_rate);
    });
    tableRight.push(temp);
  });
  pageNum = Math.ceil(xData.length / 5);
  tableNum = Math.ceil(tableRight.length / 26);

  moSalaryCity.xData = xData;
  moSalaryCity.yData = yData;
  moSalaryCity.overview = overview;
  moSalaryCity.labels = res.total_city_data  || [];
  moSalaryCity.tableLeft = tableLeft;
  moSalaryCity.tableRight = tableRight;
  moSalaryCity.tableHead = uniq(years);
  moSalaryCity.pageNum = pageNum;
  moSalaryCity.tableNum = tableNum;
});

export default moSalaryCity;
export { initSalaryCity };
